import { mediaUploadService } from './Common';
export type { IMediaUploadRequest } from './ICommon';

export const CommonServices = { mediaUploadService };
